import { DocumentType } from '@/globalTypes';

const documentTypeNameOverride: Partial<Record<DocumentType, string>> = {
  [DocumentType.UtilityBill]: 'ProofOfAddress',
};

export const getDocumentTypeName = (documentType: DocumentType) => {
  return documentTypeNameOverride[documentType] ?? documentType;
};
